import Strings from "utils/strings"

export const createInfoWindowContent = (trackingIds: string[]): string => {
	const items =
		trackingIds.length > 0
			? trackingIds
					.map(
						(id) => `
			<div style="
				display: flex;
				align-items: center;
				gap: 8px;
				padding: 8px 12px;
				background: #f8f9fa;
				border-radius: 6px;
				margin-bottom: 6px;
			">
				<div style="
					width: 8px;
					height: 8px;
					background: #1890ff;
					border-radius: 50%;
					flex-shrink: 0;
				"></div>
				<span style="
					font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
					font-size: 12px;
					color: #333;
					word-break: break-all;
				">${id}</span>
			</div>
		`
					)
					.join("")
			: `<div style="color: #999; font-size: 13px; padding: 8px;">${Strings.routes.fleetTracking.noTrackingId}</div>`

	return `
		<div style="
			min-width: 280px;
			max-width: 350px;
			padding: 12px;
			font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
		">
			<div style="
				display: flex;
				align-items: center;
				gap: 8px;
				margin-bottom: 12px;
				padding-bottom: 10px;
				border-bottom: 1px solid #eee;
			">
				<div style="
					width: 32px;
					height: 32px;
					background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
					border-radius: 8px;
					display: flex;
					align-items: center;
					justify-content: center;
				">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="white">
						<path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
					</svg>
				</div>
				<div>
					<div style="font-weight: 600; font-size: 14px; color: #333;">${Strings.routes.fleetTracking.deliveryStop}</div>
					<div style="font-size: 12px; color: #888;">${trackingIds.length} ${Strings.routes.fleetTracking.orders}</div>
				</div>
			</div>
			<div style="max-height: 200px; overflow-y: auto;">
				${items}
			</div>
		</div>
	`
}

export const isSameDay = (taskDate: Date, routeDateStr: string): boolean => {
	const route = new Date(routeDateStr)
	return (
		taskDate.getFullYear() === route.getFullYear() &&
		taskDate.getMonth() === route.getMonth() &&
		taskDate.getDate() === route.getDate()
	)
}
